import React from 'react';
import styles from './Polygon.module.css';
import classNames from 'classnames';
import { FaDrawPolygon } from 'react-icons/fa';

interface PolygonProps {
  isActive: boolean;
}

const Polygon = (props: PolygonProps) => {
  return (
    <div
      className={classNames(
        styles.polygonContainer,
        props.isActive ? styles.aktivPolygon : ''
      )}
    >
      <FaDrawPolygon size="25" />
    </div>
  );
};

export default Polygon;
